import { render, staticRenderFns } from "./ApplicationDetailsDynamicData.vue?vue&type=template&id=1a2ba4b5&"
import script from "./ApplicationDetailsDynamicData.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailsDynamicData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports